import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJenkinsxComponent } from './simple-icons-jenkinsx.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJenkinsxComponent ],
    exports:      [ SimpleIconsJenkinsxComponent ],
    bootstrap:    []
})
export class SimpleIconsJenkinsxModule {}
